import React, { useState } from 'react';
import { CompanyPageContainer, CompanyPageContent, TopPanel, BottomPanel, TimelineContainer, CompanyInfoTable } from './styled';
import { TabBar, TextCard, TimelineBlock } from "../../components"
import { VISION, TIMELINE, INFORMATION } from "../../const"
import map from "../../images/directions.png"

function Greetings() {
    return (
        <CompanyPageContent>
            <TopPanel>
                "다양한 실무를 바탕으로 축적된 경험과 전문 노하우를 갖춘 전문가들로 구성된 맨파워"
            </TopPanel>
            
            <BottomPanel>

                고객의 입장에서 생각하는 고객의 Needs에 대한 충분한 고민, <br />
                분명한 개발 Concept 설정과 디자인 감각과 설계, 철저한 분석, <br />
                입체적 전략수입, 프로젝트 관리와 수행이라는 단어로 개발회사를 표현합니다. <br />
                그러나 저희 디벨로시티는 여기에 만족하지 않고 <br />
                어려운 투자개발 사업시장에서도 배우며, 한 걸음씩 이루어 보여주고, <br />
                진정한 가치발견과 최고 가치를 제공하는데 열정을 가진 도전, <br />
                그리고 행복 나눔의 비전을 이루어가는 기업으로 <br />
                자리매김할 수 있도록 노력하겠습니다. <br /><br />

                성원해 주신 고객과 믿음으로 함께한 파트너, 미래가치를 제공할 고객에게 심심한 감사를 드립니다. <br />
                앞으로도 도시를 발전시키고 고객과 행복을 나누는 것에 앞장서겠습니다. <br /><br />

                감사합니다. <br /><br />

                <div className="right">(주)디벨로시티 대표이사 이상용</div>
                <br />

            </BottomPanel>
        </CompanyPageContent>
    );
}

function Vision() {
    return (
        <CompanyPageContent>
            {VISION.map((item, idx) => {
                return <TextCard title={item.title} content={item.content} maxWidth={"800px"} />
            })}
        </CompanyPageContent>
    );
}

function Timeline() {

    const length = TIMELINE.length;

    return (
        <CompanyPageContent>
            <TimelineContainer>
                {TIMELINE.map((item, idx) => {
                    return <TimelineBlock year={item.year} event={item.event} lastYear={idx === length-1} />
                })}
            </TimelineContainer>
        </CompanyPageContent>
    );
}

function Directions() {
    return (
        <CompanyPageContent>
            <img src={map} alt="" />

            <CompanyInfoTable>
                <table>
                    <tbody>
                        <tr>
                            <td>주소</td>
                            <td>{INFORMATION.address}</td>
                        </tr>
                        <tr>
                            <td>전화번호</td>
                            <td>{INFORMATION.phone_number}</td>
                        </tr>
                        <tr>
                            <td>팩스</td>
                            <td>{INFORMATION.fax}</td>
                        </tr>
                    </tbody>
                </table>
            </CompanyInfoTable>
        </CompanyPageContent>
    );
}

function CompanyPage() {
    const tabNames = ["인사말", "비전", "연혁", "찾아오시는길"];

    const [tab, setTab] = useState(tabNames[0]);

    return (
        <CompanyPageContainer>
            
            <h1 className="header">회사소개</h1>

            <TabBar list={tabNames} current={tab} setCurrent={setTab}/>

            <div style={{ margin: "30px" }}>
                { tab === tabNames[0] ? Greetings() : 
                  tab === tabNames[1] ? Vision() : 
                  tab === tabNames[2] ? Timeline() : 
                  tab === tabNames[3] ? Directions() : null }
            </div>

        </CompanyPageContainer>
    );
}

export default CompanyPage;